class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    if (updateURLHash && window.BeTagSearchTitle) {
      searchParams = window.BeTagSearchTitle.carry(searchParams, window.location.search).toString();
    }
    if (document.querySelector('[data-be-relevant-search]') && window.beRelevantSearch) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      return window.beRelevantSearch(searchParams, updateURLHash);
    }
    const request = FacetFiltersForm.renderRequest = (FacetFiltersForm.renderRequest || 0) + 1;
    document.dispatchEvent(new CustomEvent('be:filters-start'));
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event, request);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, request = FacetFiltersForm.renderRequest) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        if (request !== FacetFiltersForm.renderRequest) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').querySelector('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams, beCollectionHeading: history.state?.beCollectionHeading }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  // Refresh only draft formulation labels. Applying results/URL remains an explicit mobile action.
  async refreshDraftFormulationCounts(form) {
    const parameter = 'filter.p.m.custom.formulation';
    if (!form.querySelector(`input[name="${parameter}"]`)) return;
    const searchParams = this.createSearchParams(form);
    const request = this.draftCountRequest = (this.draftCountRequest || 0) + 1;
    this.draftCountController?.abort();
    if (document.querySelector('[data-be-relevant-search]')) {
      window.beRelevantSearchDraftCounts?.(form, searchParams);
      return;
    }
    const controller = this.draftCountController = new AbortController();
    try {
      const params = new URLSearchParams(searchParams);
      params.delete('page');
      params.set('section_id', FacetFiltersForm.getSections()[0].section);
      const response = await fetch(`${location.pathname}?${params}`, { signal: controller.signal });
      if (!response.ok) throw new Error('Facet counts unavailable');
      const html = await response.text();
      if (request !== this.draftCountRequest || !form.isConnected || this.createSearchParams(form) !== searchParams) return;
      const source = new DOMParser().parseFromString(html, 'text/html');
      const values = [...source.querySelectorAll(`#FacetFiltersFormMobile input[name="${parameter}"]`)];
      form.querySelectorAll(`input[name="${parameter}"]`).forEach(input => {
        const incoming = values.find(value => value.value === input.value);
        if (!incoming) return;
        const label = input.closest('label'), sourceLabel = incoming.closest('label');
        // Shopify's rendered labels contain its filter_value.count (including zero counts).
        for (const selector of ['.facet-checkbox__text', '.visually-hidden']) {
          const target = label?.querySelector(selector), replacement = sourceLabel?.querySelector(selector);
          if (target && replacement) target.innerHTML = replacement.innerHTML;
        }
        input.disabled = incoming.disabled && !input.checked;
        label?.classList.toggle('disabled', input.disabled);
      });
    } catch (error) {
      // Leave the current draft intact on network failure; Apply still uses the normal renderer.
      if (error.name !== 'AbortError') form.dispatchEvent(new CustomEvent('be:facet-count-error'));
    }
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
  }

  connectedCallback() {
    const rangeMin = this.querySelector('input[type="range"][aria-label="から"]');
    const rangeMax = this.querySelector('input[type="range"][aria-label="まで"]');
    const inputMin = this.querySelector('input[type="number"][aria-label="から"]');
    const inputMax = this.querySelector('input[type="number"][aria-label="まで"]');

    if (!rangeMin || !rangeMax || !inputMin || !inputMax) {
      console.warn('<price-range> 必須inputが見つかりません');
      return;
    }

    const updateRangeStyle = () => {
      const minPercent = (parseInt(rangeMin.value) / parseInt(rangeMin.max)) * 100;
      const maxPercent = (parseInt(rangeMax.value) / parseInt(rangeMax.max)) * 100;
      this.querySelector('.range-group').style.setProperty('--range-min', `${minPercent}%`);
      this.querySelector('.range-group').style.setProperty('--range-max', `${maxPercent}%`);
    };

    const syncFromNumberMin = () => {
      inputMin.value = Math.max(
        Math.min(parseInt(inputMin.value) || 0, parseInt(inputMax.value || rangeMin.max) - 1),
        parseInt(inputMin.min)
      );
      rangeMin.value = inputMin.value;
      updateRangeStyle();
    };

    const syncFromNumberMax = () => {
      inputMax.value = Math.min(
        Math.max(parseInt(inputMax.value) || 0, parseInt(inputMin.value || rangeMax.min) + 1),
        parseInt(inputMax.max)
      );
      rangeMax.value = inputMax.value;
      updateRangeStyle();
    };

    const syncFromRangeMin = () => {
      rangeMin.value = Math.min(parseInt(rangeMin.value), parseInt(inputMax.value || rangeMin.max) - 1);
      inputMin.value = rangeMin.value;
      updateRangeStyle();
    };

    const syncFromRangeMax = () => {
      rangeMax.value = Math.max(parseInt(rangeMax.value), parseInt(inputMin.value || rangeMax.min) + 1);
      inputMax.value = rangeMax.value;
      updateRangeStyle();
    };

    // number → range 同期
    inputMin.addEventListener("input", syncFromNumberMin, { signal: this.abortController.signal });
    inputMax.addEventListener("input", syncFromNumberMax, { signal: this.abortController.signal });
    inputMin.addEventListener("change", syncFromNumberMin, { signal: this.abortController.signal });
    inputMax.addEventListener("change", syncFromNumberMax, { signal: this.abortController.signal });

    // range → number 同期
    rangeMin.addEventListener("input", syncFromRangeMin, { signal: this.abortController.signal });
    rangeMax.addEventListener("input", syncFromRangeMax, { signal: this.abortController.signal });
    rangeMin.addEventListener("change", syncFromRangeMin, { signal: this.abortController.signal });
    rangeMax.addEventListener("change", syncFromRangeMax, { signal: this.abortController.signal });

    // 初期スタイル
    updateRangeStyle();
  }

  disconnectedCallback() {
    this.abortController.abort();
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
